<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择装货地址"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :customShow="customShow"
      :showName="showName"
      :disabled="disabled"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        {{ scope.row[scope.column.property] }}
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  selectSysStaticDataByCodeType,
} from 'api';
import {
  cityAddressQueryPage,
} from 'api/distribution';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customerNameDisabled: {
      type: Boolean,
      default: false,
    },
    addressTypeDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'addressDtl',
      tableSelectTar: 'addressDtl',
      searchBoxDataTmpl: {
        addressTypeOptions: [],
        form: [
          {
            label: '客户名称',
            value: 'customerName',
            type: 'input',
            placeholder: '请输入客户名称',
            disabled: this.customerNameDisabled,
          },
          {
            label: '地址类型',
            value: 'addressType',
            type: 'select',
            placeholder: '请选择地址类型',
            disabled: this.addressTypeDisabled,
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'customerName',
          label: '客户名称',
        },
      ],
      tableTitle: [
        {
          prop: 'customerName',
          label: '客户名称',
        },
        {
          prop: 'addressTypeName',
          label: '地址类型',
        },
        {
          prop: 'addressDtl',
          label: '出发详细地址',
        },
      ],
    };
  },
  methods: {
    getListApi: cityAddressQueryPage,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
    async getOptions () {
      if (!this.searchBoxDataTmpl.addressTypeOptions.length) {
        const addressTypeOptions = await selectSysStaticDataByCodeType({
          codeType: 'CITY_ADDRESS_TYPE',
          hasAll: true,
        });
        this.searchBoxDataTmpl.addressTypeOptions = addressTypeOptions.filter((item) => item.value !== '-1');
      }
    },
  },
  async mounted () {
    await this.getOptions();
  },
};
</script>

<style>
</style>
